import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {Router} from '@angular/router';

@Injectable()
export class RegisterGuard implements CanActivate {
  constructor(private router: Router) {
  }

  canActivate() {
    if (localStorage.getItem('mobileUserToken')) {
      this.router.navigate(['/']);
      return true;
    }
    this.router.navigate(['/register']);
    return false;
  }
}
